import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
} from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { UtilitiesService } from "src/app/core/service/utilities.service";
import Swal from "sweetalert2";
import * as _ from "lodash";
import * as moment from "moment";
import { ModalViewreseauDeSoinDetailComponent } from "../../modal-view-reseau-soin-detail/modal-view-reseau-soin-detail.component";


@Component({
  selector: 'app-souscripteur-base-info',
  templateUrl: './souscripteur-base-info.component.html',
  styleUrls: ['./souscripteur-base-info.component.scss']
})
export class SouscripteurBaseInfoComponent implements OnInit {

busyGet: Subscription;
  filiale_id: any;
  user: any = {};
  currentData: any;
  modalRef:BsModalRef
  @Input() souscripteurData:any
  @Output() onGetGarantInfo= new EventEmitter<any>();

  itemSouscripteur: any = {};
  itemsFiliale: any;
  isDetailMode=true
  itemsVille: any;
  itemsTypeSouscripteur: any;
  itemsModeProrata: any;

  constructor(
    public bsModalRef: BsModalRef,
    private authService: AuthService,
    private restClient: RestClientService,
    private modalService:BsModalService
  ) {
    this.user = this.authService.getCurrentUser();
    this.filiale_id = this.user.filiale_id;
    console.log("this.currentData: ", this.currentData);
    // setTimeout(() => {
    //   if (this.currentData) {
    //     this.getitemSouscripteur(this.currentData.id);
    //   }
    // }, 50);

    
  }

 
  ngOnChanges(changes: SimpleChanges) {
    console.log('changes: ',changes)

    if (changes.souscripteurData && changes.souscripteurData.currentValue) {
      setTimeout(() => {
        // debugger
        
        // this.getItemsSecteurUser(changes.userId.currentValue)
        let souscripteur = changes.souscripteurData.currentValue
        this.getitemSouscripteur(souscripteur.id)
        
          });
    }
    
  }
  
  getItemsFiliale() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("filiale/getByCriteria", request)
      .subscribe(
        (res) => {
          console.info("itemsFiliale", res);

          if (res && res["items"]) {
            this.itemsFiliale = _.orderBy(res["items"], ["libelle"], ["asc"]);
          } else {
            this.itemsFiliale = [];
          }
        },
        (err) => {}
      );
  }

  getitemSouscripteur(souscripteur_id) {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {
        id: souscripteur_id,
      },
    };

    this.busyGet = this.restClient
      .post("souscripteur/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemSouscripteur = res["items"][0];
            console.log("data to emit: ",this.itemSouscripteur)
            // this.onGetGarantInfo.emit(this.itemSouscripteur)
          } else {
            this.itemSouscripteur = {};
            // this.onGetGarantInfo.emit({})

          }
        },
        (err) => {
          this.itemSouscripteur = {};
        }
      );
  }

  handleImageError(item) {
    item.image_url = "assets/images/custom/user-ano.jpeg";
  }

  openModalReseau() {
    if(!this.itemSouscripteur.reseau_de_soin_id)
      return
    let modal: any;
    modal = ModalViewreseauDeSoinDetailComponent;
    this.modalRef = this.modalService.show(modal, {
      id: 54581554500,
      class: "modal-width-75",
      ignoreBackdropClick: true,
      // data:boulangerie
    });
 
    let data = {reseau_de_soin_id:this.itemSouscripteur.reseau_de_soin_id,reseau_de_soin_libelle:this.itemSouscripteur.reseau_de_soin_libelle}
    if (data) this.modalRef.content.currentData = data;
    this.modalRef.onHide.subscribe((res) => {
    });
  
  
  }
  getItemsTypeSouscripteur() {
      let request = {
        user_id: this.user.id,
        filiale_id:this.user.filiale_id,
        index: 0,
        size: 1000,
        order_by:'libelle',
        data: {},
      };
  
      this.busyGet = this.restClient
        .post("typeSouscripteur/getByCriteria", request)
        .subscribe(
          (res) => {
            console.info("itemsTypeSouscripteur", res);
  
            if (res && res["items"]) {
              this.itemsTypeSouscripteur = res["items"]
            } else {
              this.itemsTypeSouscripteur = [];
            }
          },
          (err) => { }
        );
    }
  
    getItemsVille() {
      let request = {
        user_id: this.user.id,
        filiale_id:this.user.filiale_id,
        index: 0,
        size: 1000,
        data: {},
      };
  
      this.busyGet = this.restClient
        .post("ville/getByCriteria", request)
        .subscribe(
          (res) => {
            console.info("itemsVille", res);
  
            if (res && res["items"]) {
              this.itemsVille = _.orderBy(
                res["items"],
                ["libelle"],
                ["asc"]
              );
            } else {
              this.itemsVille = [];
            }
          },
          (err) => { }
        );
    }
    onChangeTypeSouscripteur(){
      if(this.itemsTypeSouscripteur && this.itemsTypeSouscripteur.length)
        this.itemSouscripteur.type_souscripteur_code = this.itemsTypeSouscripteur.filter(its=>its.id ==this.itemSouscripteur.type_souscripteur_id )[0].codification
    }

    getItemsModeProrata() {
      let request = {
        user_id: this.user.id,
        filiale_id:this.user.filiale_id,
        index: 0,
        size: 1000,
        data: {},
      };
    
      this.busyGet = this.restClient
        .post("modeProrata/getByCriteria", request)
        .subscribe(
          (res) => {
            if (res && res["items"]) {
              this.itemsModeProrata = _.orderBy(
                res["items"],
                ["libelle"],
                ["asc"]
              );
            } else {
              this.itemsModeProrata = [];
            }
          },
          (err) => { 
            this.itemsModeProrata = [];
    
          }
        );
    }
  

  ngOnInit() {
    this.getItemsFiliale();
    this.getItemsTypeSouscripteur()
    this.getItemsModeProrata()
    this.getItemsVille()
  }

}
